import { Outlet, createRootRoute } from '@tanstack/react-router'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ThemeProvider } from '@/theme/theme-provider'
import { Toaster } from '@/components/ui/toaster'
import { LegacyQueryRedirect } from '@/lib/legacy-route-redirect'

export const Route = createRootRoute({
	component: RootLayout,
})

function RootLayout() {
	return (
		<ThemeProvider>
			<TooltipProvider>
				<LegacyQueryRedirect />
				<Outlet />
				<Toaster />
			</TooltipProvider>
		</ThemeProvider>
	)
}
